import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Cart = () => {

    const [count, setCount] = useState(1);
    const handleMinus = () => {
        setCount((prev) => {
            const newCount = prev - 1 < 1 ? 1 : prev - 1;
            return newCount;
        });
    };

    const handlePlus = () => {
        setCount((prev) => prev + 1);
    };

    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Cart</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="inner-cart-sec">
                <section className="shopping_cart">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-12 col-12 wow fadeInLeft" data-wow-duration="2s">
                                <div className="shopping_cart_table">
                                    <h2>Shopping Cart</h2>
                                    <div className="table-responsive">
                                        <table className="w-100">
                                            <thead>
                                                <tr>
                                                    <th className="w-60">Product</th>
                                                    <th>Quantity</th>
                                                    <th>Total Price</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="cart_box_product">
                                                            <div className="cart_product_img">
                                                                <img src="images/inner-cart-1.jpg" />
                                                            </div>
                                                            <div className="cart_product_name">
                                                                <p>products name here<br />dolor sit </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="quanity product-detail">
                                                            <div className="num-block skin-2">
                                                                <div className="num-in">
                                                                    <span className={`minus ${count <= 1 ? "dis" : ""}`} onClick={handleMinus} />
                                                                    <input className="in-num" type="text" value={count}
                                                                        onChange={(e) => setCount(Number(e.target.value) || 1)}
                                                                        readOnly />
                                                                    <span className="plus" onClick={handlePlus} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p className="t_price">$59.00</p>
                                                    </td>
                                                    <td>
                                                        <Link to=""><i className="fas fa-times" /></Link>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="cart_recipt">
                                        <Link to="/products"><i className="fas fa-angle-left" /> Continue Shopping</Link>
                                        <div className="recipt">
                                            <ul>
                                                <li>Subtotal <span>$149.96</span></li>
                                                <li>Shipping <span>$9.99</span></li>
                                                <li>Total <span>$149.96</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-5 col-sm-12 col-12 wow fadeInRight" data-wow-duration="2s">
                                <div className="payment_card">
                                    <h3>Payment Info</h3>
                                    <div className="credit_paypal">
                                        <label>total price</label><br />
                                        <Link href><img src="images/credit.png" />Credit card</Link>
                                        <Link href><img src="images/paypa.png" /> Paypal</Link>
                                    </div>
                                    <form>
                                        <label>Name On Card:</label>
                                        <input type="text" name="name_card" placeholder="Anton Pecherits 4" />
                                        <label>Card Number:</label>
                                        <input type="number" name="car_number" placeholder="**** **** **** **** 3271" />
                                        <div className="expiry_cvv">
                                            <div className="expiry_date">
                                                <div className="label_expiry">
                                                    <label>Expiration Date:</label>
                                                </div>
                                                <div className="month_year">
                                                    <select>
                                                        <option selected disabled>MM</option>
                                                        <option value={1}>Janaury</option>
                                                        <option value={2}>February</option>
                                                        <option value={3}>March</option>
                                                        <option value={4}>April</option>
                                                        <option value={5}>May</option>
                                                        <option value={6}>June</option>
                                                        <option value={7}>July</option>
                                                        <option value={8}>August</option>
                                                        <option value={9}>September</option>
                                                        <option value={10}>October</option>
                                                        <option value={11}>November</option>
                                                        <option value={12}>December</option>
                                                    </select>
                                                    <select id="year" name="year">
                                                        <option value>YYYY</option>
                                                        <option value={2000}>2000</option>
                                                        <option value={2001}>2001</option>
                                                        <option value={2002}>2002</option>
                                                        <option value={2003}>2003</option>
                                                        <option value={2004}>2004</option>
                                                        <option value={2005}>2005</option>
                                                        <option value={2006}>2006</option>
                                                        <option value={2007}>2007</option>
                                                        <option value={2008}>2008</option>
                                                        <option value={2009}>2009</option>
                                                        <option value={2010}>2010</option>
                                                        <option value={2011}>2011</option>
                                                        <option value={2012}>2012</option>
                                                        <option value={2013}>2013</option>
                                                        <option value={2014}>2014</option>
                                                        <option value={2015}>2015</option>
                                                        <option value={2016}>2016</option>
                                                        <option value={2017}>2017</option>
                                                        <option value={2018}>2018</option>
                                                        <option value={2019}>2019</option>
                                                        <option value={2020}>2020</option>
                                                        <option value={2021}>2021</option>
                                                        <option value={2022}>2022</option>
                                                        <option value={2023}>2023</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="cvv_box">
                                                <label>CVV</label>
                                                <input type="number" min={0} max={3} name="cvv" placeholder="XXXX" />
                                            </div>
                                        </div>
                                        <div className="cart-btn">
                                            <Link to="/checkout" className="theme-btn-1">Submit NOw </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Cart